import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["checkbox"]
  static values = { updateUrl: String }

  connect() {
    this.toggle();
  }

  toggle() {
    const shippingForm = document.getElementById("shipping-address-card");
    const checkbox = this.checkboxTarget; 
    
    if (checkbox.checked) {
      shippingForm.style.display = 'none';
    } else {
      shippingForm.style.display = 'block';
    }
    this.updateOrderSummary();
  }

  async updateOrderSummary() {
    const form = this.element.closest("form");
    if (!form) return;

    const formData = new FormData(form);
    const updateUrl = document.querySelector('[data-dynamic-states-update-url-value]').dataset.dynamicStatesUpdateUrlValue;

    await post(updateUrl, {
      body: formData,
      responseKind: "turbo-stream"
    });
  }
}